import { Component } from '@theme/component';
import { ThemeEvents } from '@theme/events';

export class CartIconComponent extends Component {
  connectedCallback() {
    super.connectedCallback();
    document.addEventListener(ThemeEvents.cartUpdate, this.#onCartUpdate);
    window.addEventListener('pageshow', this.#onPageShow);
    this.#ensureCartBubbleIsCorrect();
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener(ThemeEvents.cartUpdate, this.#onCartUpdate);
    window.removeEventListener('pageshow', this.#onPageShow);
  }

  #onCartUpdate = (event) => {
    const itemCount = event.detail?.data?.itemCount;
    if (typeof itemCount !== 'number') {
      /* Fall back to resource.item_count if data.itemCount is absent */
      const resourceCount = event.detail?.resource?.item_count;
      if (typeof resourceCount === 'number') {
        this.#renderCartBubble(resourceCount, event.detail?.data?.source, true);
      }
      return;
    }

    const source = event.detail?.data?.source;
    this.#renderCartBubble(itemCount, source, true);
  };

  #renderCartBubble(itemCount, source, animate = true) {
    let badge = this.querySelector('.site-header__cart-badge');
    const totalCount = source === 'product-form-component'
      ? this.#getCurrentCount() + itemCount
      : itemCount;

    if (totalCount > 0) {
      if (!badge) {
        badge = document.createElement('span');
        badge.className = 'site-header__cart-badge';
        badge.setAttribute('aria-hidden', 'true');
        const button = this.querySelector('button');
        if (button) {
          button.appendChild(badge);
        } else {
          this.appendChild(badge);
        }
      }
      badge.textContent = String(totalCount);
    } else if (badge) {
      badge.remove();
    }

    /* Persist so bfcache restores the correct count */
    try {
      sessionStorage.setItem(
        'cart-count',
        JSON.stringify({ value: String(totalCount), timestamp: Date.now() })
      );
    } catch {
      /* sessionStorage not available */
    }
  }

  #getCurrentCount() {
    const badge = this.querySelector('.site-header__cart-badge');
    if (!badge) return 0;
    return parseInt(badge.textContent, 10) || 0;
  }

  #onPageShow = (event) => {
    if (event.persisted) {
      this.#ensureCartBubbleIsCorrect();
    }
  };

  #ensureCartBubbleIsCorrect() {
    try {
      const stored = sessionStorage.getItem('cart-count');
      if (!stored) return;
      const { value, timestamp } = JSON.parse(stored);
      /* Only trust stored count within 10 seconds */
      if (Date.now() - timestamp > 10000) return;
      const count = parseInt(value, 10);
      if (count >= 0) {
        this.#renderCartBubble(count, undefined, false);
      }
    } catch {
      /* ignore */
    }
  }
}

if (!customElements.get('cart-icon-component')) {
  customElements.define('cart-icon-component', CartIconComponent);
}
